// Assets
import wifi from "../assets/images/wifi.png";
import rending from "../assets/images/rending.png";
import featured from "../assets/images/featured.png";
import groups from "../assets/images/groups.png";
import schoolDashboard from "../assets/images/schoolDashboard.png";
import highlightIMG from "../assets/images/highlightIMG.png";
import { getFromLocalStorage } from "../utils/webStorage";
import teams from "../assets/images/teams.png";
import scoaches from "../assets/images/scoaches.png";
import Sathelete from "../assets/images/Sathelete.png";

import { AiFillHome } from "react-icons/ai";
import { FaDatabase } from "react-icons/fa";
import {
  MdVideoLibrary,
  MdGroups,
  MdEventAvailable,
  MdTrendingUp,
  MdRssFeed,
} from "react-icons/md";
import { BsGraphUp } from "react-icons/bs";

var itemsList1 = [
  {
    text: "Feed",
    icon: <img src={wifi} alt="school" />,
    path: "/athletedashboard",
    liname: "athletedashboard",
  },
  {
    text: "Trending",
    icon: <img src={rending} alt="coaches" />,
    path: "/trending",
    liname: "trending",
  },
];

var itemsList2 = [
  {
    text: "Feed",
    icon: <img src={wifi} alt="school" />,
    path: "/teamadmindashboard",
    liname: "teamadmindashboard",
  },
  {
    text: "Trending",
    icon: <img src={rending} alt="coaches" />,
    path: "/trending",
    liname: "trending",
  },
  {
    text: "Groups",
    icon: <MdGroups />,
    path: "/groups",
    liname: "groups",
  },
];

var coachesList2 = [
  {
    text: "Feed",
    icon: <img src={wifi} alt="school" />,
    path: "/coachdashboard",
    liname: "coachdashboard",
  },
  {
    text: "Trending",
    icon: <img src={rending} alt="coaches" />,
    path: "/trending",
    liname: "trending",
  },
  {
    text: "Groups",
    icon: <MdGroups />,
    path: "/groups",
    liname: "groups",
  },
];

var itemsList3 = [
  {
    text: "Homepage",
    icon: <AiFillHome />,
    path: "/schooladmindata",
    liname: "schooladmindata",
  },

  {
    text: "Library",
    icon: <MdVideoLibrary />,
    path: "/videoplayer",
    liname: "videoplayer",
  },
  {
    text: "Groups",
    icon: <MdGroups />,
    path: "/groups",
    liname: "groups",
  },
  {
    text: "Season",
    icon: <MdEventAvailable />,
    path: "/seasons",
    liname: "seasons",
  },
  {
    text: "Reports",
    icon: <BsGraphUp />,
    path: "/reports",
    liname: "reports",
  },
];

const schoolAdminList = [
  {
    text: "Team Admin",
    icon: <img src={teams} alt="teams" />,
    path: "/teamadmin",
    liname: "teamadmin",
  },

  {
    text: "Coaches",
    icon: <img src={scoaches} alt="scoaches" />,
    path: "/schoolcoaches",
    liname: "schoolcoaches",
  },
  {
    text: "Athlete",
    icon: <img src={Sathelete} alt="Sathelete" />,
    path: "/schoolathletes",
    liname: "schoolathletes",
  },
];

const coachesList = [
  {
    text: "Coaches",
    icon: <img src={scoaches} alt="scoaches" />,
    path: "/schoolcoaches",
    liname: "schoolcoaches",
  },
  {
    text: "Athlete",
    icon: <img src={Sathelete} alt="Sathelete" />,
    path: "/schoolathletes",
    liname: "schoolathletes",
  },
];

const athleteList = [
  {
    text: "Athlete",
    icon: <img src={Sathelete} alt="Sathelete" />,
    path: "/schoolathletes",
    liname: "schoolathletes",
  },
];

var itemsList5 = [
  {
    text: "Library",
    icon: <MdVideoLibrary />,
    path: "/videoplayer",
    liname: "videoplayer",
  },
  {
    text: "Feed",
    icon: <MdRssFeed />,
    path: "/teamadmindashboard",
    liname: "teamadmindashboard",
  },
  {
    text: "Groups",
    icon: <MdGroups />,
    path: "/groups",
    liname: "groups",
  },
  {
    text: "Hours",
    icon: <FaDatabase />,
    path: "/hours",
    liname: "hours",
  },
  {
    text: "Trending",
    icon: <MdTrendingUp />,
    path: "/trending",
    liname: "trending",
  },
];

var coachesList5 = [
  {
    text: "Library",
    icon: <MdVideoLibrary />,
    path: "/videoplayer",
    liname: "videoplayer",
  },
  {
    text: "Feed",
    icon: <MdRssFeed />,
    path: "/coachdashboard",
    liname: "coachdashboard",
  },
  {
    text: "Groups",
    icon: <MdGroups />,
    path: "/groups",
    liname: "groups",
  },
  // {
  //   text: "Hours",
  //   icon: <FaDatabase />,
  //   path: "/hours",
  //   liname: "hours",
  // },
  {
    text: "Trending",
    icon: <MdTrendingUp />,
    path: "/trending",
    liname: "trending",
  },
];

export {
  athleteList,
  coachesList,
  schoolAdminList,
  coachesList2,
  coachesList5,
  itemsList1,
  itemsList2,
  itemsList3,
  itemsList5,
};
